import { Component, Input, OnInit } from '@angular/core'
import { BreadcrumbLink } from '../../../../shared/interfaces/breadcrumb-link.interface'
import { EventService } from '../../../../shared/services/event.service'

@Component({
  selector: 'app-tools-catalogue-menu',
  templateUrl: './tools-catalogue-menu.component.html',
  styleUrls: ['./tools-catalogue-menu.component.scss']
})
export class ToolsCatalogueMenuComponent implements OnInit {
  @Input() breadcrumbLinks: BreadcrumbLink[]

  isToolsSection: boolean
  isMetricsSection: boolean

  constructor(private eventService: EventService) {}

  ngOnInit() {
    this.eventService.routeChanged.subscribe((route) => {
      this.isToolsSection =
        route.url.includes('/catalogue/tools') ||
        route.url.includes('/catalogue/tool-use-cases')
      this.isMetricsSection =
        route.url.includes('/catalogue/metrics') ||
        route.url.includes('/catalogue/metric-use-cases')
    })
  }
}
